let dragDestIndex;
let draggedEl;
let draggedElIndex;
let rearranging = false;
let rearrangingDuration = 350;
let draggableElArr = $('.draggable');

// Update the CSS for each item to be in its correct location based on the order in the array passed
// @param itemEls: the DOM elements, in order, from top left, row by row
// @param columnsCount: the number of columns
// @containerEl: the DOM element of the container for the arranged elements.
function arrangeItems(itemEls, columnsCount, rowsCount, containerEl) {
    const $containerEl = $(containerEl);

    // Set height of elements
    const elWidth = $containerEl.width() / columnsCount;
    const elHeight = $containerEl.height() / rowsCount;

    for (let i = 0; i < itemEls.length; i++) {
        const $item = $(itemEls[i]);
        $item.data('index', i);
        const pos = {
            x: Math.floor(i / rowsCount),
            y: i % rowsCount
        };

        $item.css({
            top: pos.y * elHeight + 'px',
            left: pos.x * elWidth + 'px',
            width: 'calc(' + (100 / columnsCount) + '% - 10px)',
            height: 'calc(' + (100 / rowsCount) + '% - 10px)',
            boxSizing: 'border-box'
        });
    }
}

// Rearrange the items in an array, returning a the modified array.
// @param movedItemIndex: the index of the element being moved to a
//   new position in the array
// @param destinationIndex: the new index being given to the moved element
function rearrangeItems(arr, movedItemIndex, destinationIndex) {
    const movedEl = arr.splice(movedItemIndex, 1)[0];
    arr.splice(destinationIndex, 0, movedEl);
    return arr;
};

arrangeItems(draggableElArr, 12, 8, $('.panel'));

$('.draggable').on('dragstart', function (e) {
    draggedEl = $(this);
    const sortedArr = [];
    for (let i = 0; i < draggableElArr.length; i++) {
        const elIndex = $(draggableElArr[i]).data('index');
        sortedArr[elIndex] = draggableElArr[i];
    }
    draggableElArr = sortedArr;
    draggedElIndex = $(this).data('index');
    $(this).css({opacity: 0, transition: 'all 100ms ease'});
});

$('.draggable').on('dragend', function (e) {
    e.preventDefault();
    $(this).css({opacity: 1, transition: 'all 700ms ease'});
});

$('.draggable').on('dragover', function (e) {
    e.preventDefault();
    if (rearranging) {
        return;
    }
    if ($(this).attr("draggable") === 'true') {
        const dragDestIndex = $(this).data('index');
        draggedElIndex = draggedEl.data('index');
        if (draggedElIndex !== dragDestIndex) {
            rearranging = true;
            const rearrangedEls = rearrangeItems(draggableElArr, draggedElIndex, dragDestIndex);
            arrangeItems(rearrangedEls, 12, 8, $('.panel'));
            setTimeout(function () {
                rearranging = false
            }, rearrangingDuration);
            $('#well-order').val(rearrangedEls.map(e => e.dataset.wellId));
        }
    }
});

$('.draggable').on('drop', function (e) {
    e.preventDefault();
    rearranging = false;
});

$('.panel-well').on('click', function(e) {
    $('#sample-form-name').text(this.textContent);
    $('#sample-id').data('well-id', this.dataset.wellId);
    $('#injection-count').val(this.dataset.injectionCount);
    $('#sample-type').val(this.dataset.sampleType);
    $(".panel-well").removeClass('selected-well');
    $(this).addClass('selected-well');
})

$('#injection-count').on('change', function(e) {
    const target = $(`.panel-well[data-well-id=${$('#sample-id').data('well-id')}]`)
    const injection_count = $(this).val();
    target.data('injection-count', parseInt(injection_count));
    $.ajax({
        url: `/kit_registration_samples/${target.data('kit-registration-sample-id')}?injection_count=${injection_count}`,
        type: 'PUT'
    });
})

$('#sample-type').on('change', function(e) {
    const target = $(`.panel-well[data-well-id=${$('#sample-id').data('well-id')}]`)
    const sample_type = $(this).val();
    const old_class = target.data('sample_type');
    const dot = target.children('.dot');
    dot.removeClass(old_class);
    dot.addClass(sample_type)
    target.data('sample_type', sample_type);
    
    $.ajax({
        url: `/kit_registration_samples/${target.data('kit-registration-sample-id')}?sample_type=${sample_type}`,
        type: 'PUT'
    });
})


